import { Button }         from '@/components/ui/button';
import { Dispatch }       from 'react';
import { Field }          from '@/components/ui/field';
import { PasswordInput }  from '@/components/ui/password-input';
import { SetStateAction } from 'react';
import { Stack }          from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import authStore          from '@/stores/authStore';
import { toaster }        from '@/components/ui/toaster';
import { useForm }        from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IPasswordFormProps {
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	onChangePasswordSuccess: () => void;
}

interface FormValues {
	newPassword: string;
	confirmNewPassword: string;
}

const PasswordForm = (props: IPasswordFormProps) => {
	const { setIsOpen, onChangePasswordSuccess } = props;
	const { t } =  useTranslation();
	const currentUser = authStore.currentUser;

	const {
		formState: { errors, isSubmitting },
		getValues,
        handleSubmit,
        register,
    } = useForm<FormValues>()
	
	const onSubmit = handleSubmit(async (data) => {
		try {
			await currentUser.patch({
				plainPassword: data.newPassword,
			});
			onChangePasswordSuccess();
			setIsOpen(false);
		} catch (error) {
			toaster.create({
                title: t('pages.security.passwordBox.modals.forms.messages.errors.error'),
                type: 'error'
            })
			console.log(error);
		}
	})

	return (
		<form onSubmit={onSubmit}>
			<Stack gap="20px" marginTop="20px">
				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.passwordBox.modals.forms.new')}
						</Text>
					}
					invalid={!!errors.newPassword}
					required
				>
					<PasswordInput
                        placeholder={t('pages.security.passwordBox.modals.forms.new')}
                        {...register("newPassword", {
							pattern: {
								value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
								message: t('pages.security.passwordBox.modals.forms.messages.errors.pattern'),
							}
						})}
                    />
					{errors.newPassword?.type === 'pattern' && <Text color="red">{t('pages.security.passwordBox.modals.forms.messages.errors.pattern')}</Text>}
				</Field>

				<Field
					label={
						<Text 
							className="poppins-semibold" 
							fontSize="14px" 
							fontWeight="bold"
						>
							{t('pages.security.passwordBox.modals.forms.confirm')}
						</Text>
					}
					invalid={!!errors.confirmNewPassword}
					required
				>
					<PasswordInput
                        placeholder={t('pages.security.passwordBox.modals.forms.confirm')}
                        {...register("confirmNewPassword", {
							validate: value => {
								const { newPassword } = getValues();
								return newPassword === value;
							},
						})}
                    />
					{errors.confirmNewPassword?.type === 'validate' && <Text color="red">{t('pages.security.passwordBox.modals.forms.messages.errors.match')}</Text>}
				</Field>

				<Button 
					variant="solid" 
					type="submit" 
					width="100%"
					marginTop="30px"
					loading={isSubmitting}
				>
					{t('pages.security.passwordBox.modals.forms.actions.save')}
				</Button>
			</Stack>
		</form>
	);
};

export default PasswordForm;